import { Capacitor } from '@capacitor/core'

import { postClientDiagnostic } from './clientDiagnostics'

export type DictationDiagnosticEvent = {
  event: 'availability' | 'start' | 'state' | 'final_result' | 'error' | 'stop'
  engine: 'native' | 'web-speech' | 'openai-transcribe'
  chat_id?: string
  topic_id?: string | null
  state?: string
  available?: boolean
  permission?: 'granted' | 'denied' | 'prompt'
  result_chars?: number
  alternatives_count?: number
  error_code?: string
  recoverable?: boolean
}

export function recordDictationDiagnostic(event: DictationDiagnosticEvent): void {
  postClientDiagnostic('/api/client-diagnostics/dictation', {
    ...event,
    native_platform: Capacitor.isNativePlatform(),
    speech_plugin: Capacitor.isPluginAvailable('AgentChatSpeech'),
  })
}
